import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { dayNoonIso } from '@app/shared/time';
import type { Day } from '@app/sales/rental-billing/rental-billing.model';

// Un dossier du payeur tel que le résume GET /sales/rental_payers/:id (mercalink-server sales/src/rental/payer.rs).
export interface PayerOrderWire {
  id: number;
  state: string;
  created: string | null;
  recipient: number | null;
  recipient_firstname: string | null;
  recipient_name: string | null;
  fse: boolean;
  memos: string[];
  rentals: number;
  returned: number;
  last_return: string | null;
  lines: number;          // lignes louées et vendues, reprises exclues
  closed_lines: number;
  closed_at: string | null;
  category: PayerCategory;
}

// open = en cours ; returned = tout le matériel repris, pas clos ; closed = toutes lignes closes (JP 29/10/2026).
export type PayerCategory = 'open' | 'returned' | 'closed' | 'canceled';

// Dossiers qui répondent à la période et à la recherche, quelles que soient les cases cochées.
export interface PayerOrdersCounts { open: number; returned: number; closed: number; canceled: number; }

export interface PayerOrdersPage { orders: PayerOrderWire[]; counts: PayerOrdersCounts; more: boolean; }

export interface PayerOrdersQuery {
  start: Day | null;
  end: Day | null;
  returned: boolean;   // dossiers dont tout le matériel est repris, pas encore clos
  closed: boolean;     // dossiers clos (toutes lignes louées et vendues closes)
  canceled: boolean;
  q: string;
  before: number | null;
  withRecipient?: boolean;   // aussi les dossiers dont ce tiers est le bénéficiaire, payés par un autre (fiche tiers, #38)
  limit?: number;            // PAYER_PAGE sinon ; le serveur plafonne à 200
}

export const PAYER_PAGE = 50;

@Injectable({ providedIn: 'root' })
export class RentalPayerService {
  private http = inject(HttpClient);

  // start/end = jours inclus, envoyés à midi heure de Paris ; filtres et pagination faits en base.
  getOrders(payer: number, f: PayerOrdersQuery): Observable<PayerOrdersPage> {
    const params: Record<string, string> = { limit: String(f.limit ?? PAYER_PAGE) };
    const start = dayNoonIso(f.start);
    const end = dayNoonIso(f.end);
    if (start) params['start'] = start;
    if (end) params['end'] = end;
    if (f.returned) params['returned'] = 'true';
    if (f.closed) params['closed'] = 'true';
    if (f.canceled) params['canceled'] = 'true';
    if (f.q.trim()) params['q'] = f.q.trim();
    if (f.before) params['before'] = String(f.before);
    if (f.withRecipient) params['with_recipient'] = 'true';
    return this.http.get<PayerOrdersPage>(`${environment.server_url}/sales/rental_payers/${payer}`, { params });
  }
}
